<script>
    import GameArea from "./GameArea.svelte";
    import GameEnd from "./GameEnd.svelte";
    import BtnCard from "./components/BtnCard.svelte";
    import { fly } from "svelte/transition";
    import { ST_time, ST_gamestart, ST_gameend } from "./stores.js";
    import { get } from "svelte/store";
    import GameTutorial from "./GameTutorial.svelte";
    let time = get(ST_time);
    ST_time.subscribe((value) => {
        time = value;
    });

    let gameStart = get(ST_gamestart);
    ST_gamestart.subscribe((value) => {
        gameStart = value;
    });

    let gameEnd = get(ST_gameend);
    ST_gameend.subscribe((value) => {
        gameEnd = value;
    });

    let gameTutorial = false;
    // tutorialStart = () => gameTutorial = true;
    const gameStartFunc = () => {
        ST_gamestart.set(true);
        gameTutorial = false;
    }
</script>

{#if !gameEnd && !gameStart && !gameTutorial}
    <div transition:fly={{ y: 100, duration:500 }} class="columns">
        <div class="column">
            <BtnCard
                btnName="はじめる【Game Start】"
                btnImagePath="GameStart.png"
                clickFunc={gameStartFunc} />
        </div>
        <div class="column">
            <BtnCard
                btnName="ゲームの説明【Game Tutorial】"
                btnImagePath="GameTutorial.png"
                clickFunc={() => (gameTutorial = true)} />
        </div>
    </div>
{:else if  !gameTutorial}
    {#if !gameEnd}
        <GameArea />
    {:else}
        <GameEnd />
    {/if}
{/if}

{#if gameTutorial}
    <GameTutorial tutorialEndFunc={gameStartFunc} />
{/if}
